class Organization {
	static getSiteFeatures(organization = {}) {
		const { features = {} } = organization;
		return features.site || {};
	}

	static getPaymentModalities(organization = {}) {
		const site = Organization.getSiteFeatures(organization);
		const modalities = site.payment_modalities || {};

		return {
			pix: modalities.pix !== false,
			creditCard: modalities.credit_card !== false,
		};
	}

	static getDefaultPaymentMethod(organization = {}) {
		const modalities = Organization.getPaymentModalities(organization);

		if (modalities.pix && !modalities.creditCard) {
			return 'pix';
		}

		if (modalities.creditCard && !modalities.pix) {
			return 'creditCard';
		}

		const locale = typeof localStorage !== 'undefined'
			? localStorage.getItem('locale')
			: null;

		return !locale || locale === 'pt' ? 'pix' : 'creditCard';
	}

	static canSwitchPaymentMethod(organization = {}) {
		const modalities = Organization.getPaymentModalities(organization);
		const locale = typeof localStorage !== 'undefined'
			? localStorage.getItem('locale')
			: null;
		const isPortuguese = !locale || locale === 'pt';

		return modalities.pix && modalities.creditCard && isPortuguese;
	}
}

export default Organization;
